// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__TdI6y","bigColWidth":"Table_bigColWidth__18Rbp","biggerColWidth":"Table_biggerColWidth__1y7WS","row":"Table_row__JLy4T","col":"Table_col__3s3EO"};